import { useEffect, useRef, useState } from 'react';

import { Col, Row, Image } from 'react-bootstrap';

import { getRoutesDirections } from '@/data/libraries/Routes';
import { Layouts } from '@/data/libraries/Layouts';

import { useLocation, useNavigate, type NavigateFunction, Location, NavLink } from 'react-router-dom';

import { useAppSelector } from '@/ui/store/helperRedux';

import type { IFooterSections } from '@/domain/interfaces/IFooterSections';
import type { IStore } from '@/domain/interfaces/IStore';


import { translate } from '@/domain/utils/translate';
import { blurButtonAfterClick } from '@/domain/utils/blurButtonAfterClick';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';

import SearchInput from '@/ui/components/store/SearchInput';

import LoginMenu from '@/ui/containers/Header/LoginMenu';

interface HeaderMobileProps {
    logo: string;
    handleShowOptionsUser: () => void;
}

/**
 * Componente HeaderMobile
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.LOGO - URL de la imagen del logo
 * @param {Function} props.handleShowLogin - Función para mostrar el modal de inicio de sesión
 * @param {Function} props.handleShowRegister - Función para mostrar el modal de registro
 * @param {Function} props.handleShowOptionsUser - Función para mostrar las opciones del usuario
  * 
 * @returns {JSX.Element} - Retorna el componente HeaderMobile
 */
const HeaderMobile = ({
    logo: logo,
    handleShowOptionsUser,
}: HeaderMobileProps): JSX.Element => {
    /** Hook para generar una navegación dentro de la aplicación. */
    const navigate: NavigateFunction = useNavigate();
    /** Hook para obtener la ubicación actual de la aplicación. */
    const location: Location = useLocation();

    /** Rutas URLs */
    const routesDirections = getRoutesDirections();

    /** State Redux de datos de la tienda */
    const storeData = useAppSelector((state) => state.storeData) as IStore;

    /** Referencia al botón de la tienda */
    const storeButton = useRef<HTMLButtonElement>(null);


    /** State con la info a mostrar en el modal  */
    const [blogSection, setBlogSection] = useState<IFooterSections | null>(storeData.blog);

    /** Hook para obtener el valor de una variable CSS de los botones del header */
    const buttonVariant = getCSSVariableValue('--link-button-variant-header');

    /** Referencia al botón del blog */
    const blogButton = useRef<HTMLButtonElement>(null);

    const handleClickStore = () => blurButtonAfterClick(storeButton, () => { navigate(routesDirections.STORE_ROUTE) });
    const handleClickBlog = () => blurButtonAfterClick(blogButton, () => { navigate(routesDirections.BLOG_ROUTE, { state: { blogSection } }) });

    useEffect(() => {
        setBlogSection(storeData.blog);
    }, [storeData]);

    return (
        <Row className='g-0 mt-3'>
            <Col xs={2} className='px-2'>
                <NavLink to={routesDirections.MAIN_ROUTE} state={{ originURL: location.pathname }}>
                    <Image
                        id='logo'
                        src={logo}
                        alt='logo'
                        onClick={() => navigate(routesDirections.MAIN_ROUTE, { state: { originURL: location.pathname } })}
                        className='logo-header-default-mobile'
                    />
                </NavLink>
            </Col>
            <Col xs={10} className='d-flex justify-content-end align-items-center'>
                <Row className='g-0'>
                    {storeData.layoutCode === Layouts.EXCLUSIVE && (
                        <>
                            {/* <Col className="d-flex justify-content-center"> */}
                            {/* <button ref={storeButton} onClick={handleClickStore} className={`${buttonVariant} link-text-standard list-inline-item m-0`} > */}
                            {/* <span className='p-large-medium paragraph-category-text'> */}
                            {/* {translate("exclusive_header.store_title")} */}
                            {/* </span> */}
                            {/* </button> */}
                            {/* </Col> */}
                            <Col className="d-flex justify-content-center p-0">
                                <button ref={blogButton} onClick={handleClickBlog} className={`${buttonVariant} link-text-standard list-inline-item  m-0`} >
                                    <span className='p-large-medium paragraph-category-text'>
                                        {translate("exclusive_header.blog_title")}
                                    </span>
                                </button>
                            </Col>
                        </>
                    )}
                    <Col>
                        <LoginMenu handleShowOptionsUser={handleShowOptionsUser} />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} className='px-2 pt-3'>
                <SearchInput />
            </Col>
        </Row>
    );
};

export default HeaderMobile;